// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__130rr","requiredAsterisk":"Info_requiredAsterisk__FVEwu"};